// extracted by mini-css-extract-plugin
export var banner = "_i2-0";
export var closeButton = "_i2-2";
export var greenCheckmark = "_i2-3";
export var hereLink = "_i2-4";
export var titleIcon = "_i2-1";